module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('api-table-block', {
    ref: "ordersTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllOrders,
      "default-sort-by": "placed_at",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(data) {
        return [_c('label', {
          key: data.item.number,
          staticClass: "css-control css-control-primary css-checkbox"
        }, [_c('input', {
          staticClass: "css-control-input",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": _vm.selectedOrders.includes(data.item.number)
          },
          on: {
            "change": function($event) {
              _vm.selectOrder(data.item.number, $event)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "css-control-indicator"
        })])]
      }
    }, {
      key: "number",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.value))])]
      }
    }, {
      key: "billing_person",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + " "), (data.item.billing_company) ? _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.billing_company))]) : _vm._e()]
      }
    }, {
      key: "placed_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.value, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('order-status-badge', {
          attrs: {
            "order": data.item
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('router-link', {
          staticClass: "btn btn-sm btn-secondary",
          attrs: {
            "to": {
              name: 'pick-orders',
              query: {
                orders: [data.item.number]
              }
            }
          }
        }, [_vm._v("Pick")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openDetailModal(data.item.id)
            }
          }
        }, [_vm._v("Details")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openManualRefundModal(data.item)
            }
          }
        }, [_vm._v("Retourneren")])], 1)]
      }
    }])
  }, [_c('template', {
    slot: "before-block-content"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('span', {
    staticClass: "d-none d-sm-inline",
    staticStyle: {
      "font-size": "medium",
      "font-weight": "bold"
    }
  }, [_vm._v(" Orderpicken: ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-rounded btn-alt-secondary mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.pickSelected
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o text-primary mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v(" Pick")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: ('Pick 20 oudste bestellingen die maar één product bevatten'),
      expression: "'Pick 20 oudste bestellingen die maar één product bevatten'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-rounded btn-alt-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pick('single')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward text-danger mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("Single")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: ('Pick 10 oudste bestellingen die minimaal twee producten bevatten'),
      expression: "'Pick 10 oudste bestellingen die minimaal twee producten bevatten'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-rounded btn-alt-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pick('multi')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward text-danger mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("Multi")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      value: ('Pick 10 oudste bestellingen'),
      expression: "'Pick 10 oudste bestellingen'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-rounded btn-alt-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pick('all')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward text-danger mx-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v("Alles")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyNLOrders),
      expression: "showOnlyNLOrders"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyNLOrders) ? _vm._i(_vm.showOnlyNLOrders, null) > -1 : (_vm.showOnlyNLOrders)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyNLOrders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyNLOrders = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyNLOrders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyNLOrders = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" NL\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyBolOrders),
      expression: "showOnlyBolOrders"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyBolOrders) ? _vm._i(_vm.showOnlyBolOrders, null) > -1 : (_vm.showOnlyBolOrders)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyBolOrders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyBolOrders = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyBolOrders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyBolOrders = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Bol\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyProcessing),
      expression: "showOnlyProcessing"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyProcessing) ? _vm._i(_vm.showOnlyProcessing, null) > -1 : (_vm.showOnlyProcessing)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyProcessing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyProcessing = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyProcessing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyProcessing = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Openstaand\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyDropship),
      expression: "showOnlyDropship"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyDropship) ? _vm._i(_vm.showOnlyDropship, null) > -1 : (_vm.showOnlyDropship)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.showOnlyDropship,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyDropship = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyDropship = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyDropship = $$c
        }
      }, _vm.refresh]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Dropshipments\n          ")])])])])], 2), _vm._v(" "), _c('barcode-scanner', {
    on: {
      "scan": _vm.handleMessage
    }
  }), _vm._v(" "), (_vm.refundDetailModalShow && _vm.refund.id !== null) ? _c('refund-detail-modal', {
    key: _vm.refundDetailModalOrderId,
    attrs: {
      "order-id": _vm.refundDetailModalOrderId,
      "refundId": _vm.refund.id,
      "includeRefundShipmentCosts": false
    },
    on: {
      "close": function($event) {
        _vm.refundDetailModalShow = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detailModalOrderId) ? _c('order-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('select-barcode-scanner-widget')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Bestellingen\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-796e3764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/orders/OrdersPage.vue
// module id = 736
// module chunks = 1